<div class="p-6 w-full">
    <div class="whiteCard p-4 md:p-5">
        <mat-tab-group>
            <mat-tab label="My Profile">
                <div class="my-profile-wrapper">
                    <form [formGroup]="accountForm" #form>
                    <div class="profile-data-wrapper">
                        <div class="user-profile">
                            <div class="user-profile-image">
                                <label for="emp-input-banner">
                                    <img src="/images/avatars/female-03.jpg" alt="user" class="uploded-img">
                                    <span class="material-icons camera-icon">photo_camera</span>
                                    <input #fileDropRef (change)="fileBrowseHandler($event, fileDropRef)"
                                        title="No Files Chosen" class="device-input-img" id="emp-input-banner"
                                        name="images" type="file" accept="image/*" />
                                </label>
                            </div>
                            <!-- <div class="user-profile-image">
                                <img src="/images/avatars/female-03.jpg" alt="user image" class="uploded-img">
                            </div> -->
                            <div class="user-details">
                                <h3>Alexa Rawles</h3>
                                <p>alexarawles&#64;gmail.com</p>
                            </div>
                        </div>
                        @if(!isPartner){
                        <div class="flex items-center justify-end">
                            <button class="btn-theme-color !min-w-[90px] px-3 py-2 rounded-md" mat-flat-button type="button"
                                (click)="updateAccount(form)" [disabled]="isLoad">
                                {{LABELS.SAVE}}
                            </button>
                        </div>
                        }
                    </div>                    
                    <div class="grid md:grid-cols-2 gap-5 gap-y-6">
                        <div class="">
                            <mat-form-field floatLabel="always" [subscriptSizing]="'dynamic'" class="w-full">
                                <mat-label>{{LABELS.FIRST_NAME}}</mat-label>
                                <mat-icon [svgIcon]="'heroicons_solid:user'" class="icon-size-5"
                                    matPrefix></mat-icon>
                                <input [formControlName]="'firstName'" placeholder="Enter First Name" matInput
                                    (keydown)="_helper.space($event)" />
                                @if (accountForm.controls.firstName.errors?.required){
                                <mat-error>
                                    {{LABELS.FIRST_NAME_REQUIRED}}
                                </mat-error>
                                }
                            </mat-form-field>
                        </div>
                        <div class="">
                            <mat-form-field floatLabel="always" [subscriptSizing]="'dynamic'" class="w-full">
                                <mat-label>{{LABELS.LAST_NAME}}</mat-label>
                                <mat-icon [svgIcon]="'heroicons_solid:user'" class="icon-size-5"
                                    matPrefix></mat-icon>
                                <input [formControlName]="'lastName'" placeholder="Enter Last Name" matInput
                                    (keydown)="_helper.space($event)" />
                                @if (accountForm.controls.lastName.errors?.required){
                                <mat-error>
                                    {{LABELS.LAST_NAME_REQUIRED}}
                                </mat-error>
                                }
                            </mat-form-field>
                        </div>
                        <div class="sm:col-span-2">
                            <mat-form-field [subscriptSizing]="'dynamic'"
                                class="w-full opacity-60 pointer-events-none">
                                <mat-label>{{LABELS.EMAIL}}</mat-label>
                                <mat-icon [svgIcon]="'heroicons_solid:envelope'" class="icon-size-5"
                                    matPrefix></mat-icon>
                                <input [formControlName]="'email'" matInput readonly class="cursor-default" />
                                @if (accountForm.controls.email.errors?.required){
                                <mat-error>
                                    {{LABELS.EMAIL_REQUIRED}}
                                </mat-error>
                                }
                                @if (accountForm.controls.email.errors?.pattern){
                                <mat-error>
                                    {{LABELS.VALID_EMAIL}}
                                </mat-error>
                                }

                            </mat-form-field>
                        </div>
                    </div>
                </form>
                </div>
            </mat-tab>
            <mat-tab label="Change Password"> Content 2 </mat-tab>
        </mat-tab-group>
    </div>
</div>